module.exports = __webpack_public_path__ + "img/推荐系统使用者.f5bb976a.png";